import React, { Component } from 'react'
import PropTypes from 'prop-types'

import AlarmModalAlarms from 'components/AlarmModal/AlarmModalAlarms'
import AlarmModalSetAlarm from 'components/AlarmModal/AlarmModalSetAlarm'

class AlarmModal extends Component {
  state = { isAlarmCreationOpen: false, editingAlarmId: 0 }

  closeAlarmSubmenuTimeout = null

  closeAlarmSubmenuHandler = (e) => {
    if (e) e.stopPropagation()
    this.setState({ isAlarmCreationOpen: false, editingAlarmId: 0 })
  }

  closeModalHandler = (e) => {
    if (e) e.stopPropagation()
    this.closeAlarmSubmenuHandler()
    this.props.toggleAlarmHandler()
  }

  toggleAlarmCreationHandler = (e) => {
    if (e) e.stopPropagation()
    this.setState((prevState) => ({
      isAlarmCreationOpen: !prevState.isAlarmCreationOpen,
      editingAlarmId: 0,
    }))
  }

  componentWillUnmount() {
    if (this.closeAlarmSubmenuTimeout) clearTimeout(this.closeAlarmSubmenuTimeout)
  }

  openEditingAlarmHandler = (alarmId) => {
    this.setState({ isAlarmCreationOpen: true, editingAlarmId: alarmId })
  }

  render() {
    const alarmComponent = this.state.isAlarmCreationOpen ? (
      <AlarmModalSetAlarm
        closeModalHandler={this.closeModalHandler}
        closeAlarmCreationHandler={this.toggleAlarmCreationHandler}
        editingAlarmId={this.state.editingAlarmId}
      />
    ) : (
      <AlarmModalAlarms
        openAlarmCreationHandler={this.toggleAlarmCreationHandler}
        closeModalHandler={this.closeModalHandler}
        openEditingAlarmHandler={this.openEditingAlarmHandler}
      />
    )

    return this.props.isAlarmModalOpen ? alarmComponent : null
  }
}

export default AlarmModal

AlarmModal.propTypes = {
  isAlarmModalOpen: PropTypes.bool.isRequired,
  toggleAlarmHandler: PropTypes.func.isRequired,
}
